import i18n from 'i18n';
import * as Yup from 'yup';

const minValue = 3 * 60;
const maxValue = 30 * 60;
const ALLOWED_PLACEHOLDERS = ['$datetime', '$username', '$email'];

export const updateSettingsValidationSchema = Yup.object().shape({
  accessTokenExpiration: Yup.number()
    .required(i18n.t('settingsPage.validation.required'))
    .typeError(i18n.t('settingsPage.validation.isNumber'))
    .min(minValue, i18n.t('settingsPage.validation.minValue', { value: minValue }))
    .max(maxValue, i18n.t('settingsPage.validation.maxValue', { value: maxValue })),
  watermarkTemplate: Yup.string()
    .required(i18n.t('settingsPage.validation.required'))
    .test('allowed-placeholders', i18n.t('settingsPage.validation.watermarkTemplatePlaceholders'), (value) => {
      if (!value) return true;
      const matches = value.match(/\$[a-zA-Z]+/g) || [];
      return matches.every((m) => ALLOWED_PLACEHOLDERS.includes(m));
    }),

  watermarkOpacity: Yup.number()
    .typeError(i18n.t('settingsPage.validation.isNumber'))
    .min(0, i18n.t('settingsPage.validation.opacityMin'))
    .max(1, i18n.t('settingsPage.validation.opacityMax')),

  watermarkRotation: Yup.number()
    .typeError(i18n.t('settingsPage.validation.isNumber'))
    .min(0, i18n.t('settingsPage.validation.rotationMin'))
    .max(360, i18n.t('settingsPage.validation.rotationMax')),

  watermarkRepeatPeriod: Yup.number()
    .typeError(i18n.t('settingsPage.validation.isNumber'))
    .min(1, i18n.t('settingsPage.validation.repeatPeriodMin')),

  watermarkFontSize: Yup.number()
    .typeError(i18n.t('settingsPage.validation.isNumber'))
    .min(6, i18n.t('settingsPage.validation.fontSizeMin'))
    .max(200, i18n.t('settingsPage.validation.fontSizeMax')),
});
